export default __webpack_public_path__ + "5c9d79b4ef101ca56e31d3940dca2cda.jpg";